export const INITIAL_STATE = {
  auth: {
    isLogin: false,
    token: "",
    userId: "",
  },
  modal: {
    isOpen: false,
    title: "",
    content: "",
  },
  spinner: {
    isOpen: false,
  },
};
